module.exports = __webpack_public_path__ + "img/cl-install-vdp_100-install-setup.d70a827d.png";